
import "./advForm.css";
import FormAddImage from '../dashboardComponents/FormAddImage'
import AdvList from './AdvList'

export default function SetAdvForm({website}) {
  return (
    <div className='advForm'>
      <h2>ניהול תמונות ספינר</h2>
        <h4>הוסף תמונה</h4>
        <FormAddImage website={website} directory={"advertisments"} dynamicPath={"settings.advertisments"} isArray={true} arrayField={false} _required={true} label={"בחר תמונה"} text={"שמור"} type={"button"} _id={"adv_image_uploader"}/>
        <AdvList website={website}/>
    </div>
  )
}
